import React from 'react';
import PropTypes from 'prop-types';

const TabLayout = props => (
  <div className="ansible-host-detail">{props.children}</div>
);

TabLayout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default TabLayout;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/AnsibleHostDetail/components/TabLayout.js